import {Injectable} from '@angular/core';
import {AbstractSaveOneService} from '../../../../../core/service/v2/service/save/abstractSaveOne.service';
import {CommunicationContentModelModel} from '../../../api/entity/communicationContentModel.model';
import {CommunicationContentModelRepository} from '../ngrx/communicationContentModel.repository';
import {CommunicationContentModelDataServiceAdapter} from '../ngrx/communicationContentModelDataService.adapter';
import {CommunicationContentModelSavePayload} from './communicationContentModelSave.payload';

@Injectable()
export class CommunicationContentModelSaveService
    extends AbstractSaveOneService<CommunicationContentModelModel, CommunicationContentModelSavePayload> {

    constructor(repository: CommunicationContentModelRepository,
                dataServiceAdapter: CommunicationContentModelDataServiceAdapter) {
        super(repository, dataServiceAdapter);
    }
}
